import {
  Button,
  Grid,
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Box,
} from "@mui/material";
import React, { useState } from "react";
import { PersonaFisicaModel } from "../../../models/PersonaFisicaModel";
import EditIcon from "@mui/icons-material/Edit";
import { displayFormatted } from "../../../utils/date";
import DisplayField from "../../shared/DisplayField";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import BeneTableComponent from "../../bene/BeneTableComponent";
import ContrattiTableComponent from "../../contratto/ContrattiTableComponent";
import CustomerCredenzialiPortaleVenditaTable from "../CustomerCredenzialiPortaleVenditaTable";
import CustomerEmailsTable from "../CustomerEmailsTable";
import CustomerIndirizziTable from "../CustomerIndirizziTable";
import CustomerTelefoniTable from "../CustomerTelefoniTable";
import PersonaFisicaFormComponent from "./PersonaFisicaFormComponent";
import { CredenzialiPortaleVenditaModel } from "../../../models/CredenzialiPortaleVenditaModel";
import { Indirizzo } from "../../../models/IndirizzoModel";
import SectionTitle from "../../shared/SectionTitle";
import { CustomerDocument } from "../../../models/api/customer/document/customer-document-model";
import CustomerDocumentTable from "../CustomerDocumentTable";
import BankAccountTable from "../BankAccountTable";
import { BankAccount } from "../../../models/api/bank-account/bank-account-model";
import BackButton from "../../shared/BackButton";

interface WithPF {
  pef: PersonaFisicaModel;
}

const PersonaFisicaDetailComponent: React.FC<WithPF> = ({ pef }) => {
  const [mainDataEditFormOpen, setMainDataEditFormOpen] =
    useState<boolean>(false);
  const toggleMainDataEditFormOpen = () =>
    setMainDataEditFormOpen(!mainDataEditFormOpen);

  // Email
  const [emailDataCreateFormOpen, setEmailDataCreateFormOpen] =
    useState<boolean>(false);
  const toggleEmailDataCreateFormOpen = () =>
    setEmailDataCreateFormOpen(!emailDataCreateFormOpen);

  // Telefono
  const [telefonoDataCreateFormOpen, setTelefonoDataCreateFormOpen] =
    useState<boolean>(false);
  const toggleTelefonoDataEditFormOpen = () =>
    setTelefonoDataCreateFormOpen(!telefonoDataCreateFormOpen);

  // Indirizzi
  const [indirizziDataCreateFormOpen, setIndirizziDataCreateFormOpen] =
    useState<boolean>(false);
  const toggleIndirizziDataEditFormOpen = () =>
    setIndirizziDataCreateFormOpen(!indirizziDataCreateFormOpen);

  // Documents
  const [documentCreateFormOpen, setDocumentCreateFormOpen] =
    useState<boolean>(false);
  const toggleDocumentEditFormOpen = () =>
    setDocumentCreateFormOpen(!documentCreateFormOpen);

  // Bank Accounts
  const [bankAccountCreateFormOpen, setBankAccountCreateFormOpen] =
    useState<boolean>(false);
  const toggleBankAccountEditFormOpen = () =>
    setBankAccountCreateFormOpen(!bankAccountCreateFormOpen);

  // Portali Vendita
  const [enableCreateButton, setEnableCreateButton] = useState<boolean>(true);
  const [
    portaliVenditaDataCreateFormOpen,
    setPortaliVenditaDataCreateFormOpen,
  ] = useState<boolean>(false);
  const togglePortaliVenditaDataCreateFormOpen = () =>
    setPortaliVenditaDataCreateFormOpen(!portaliVenditaDataCreateFormOpen);

  // Beni
  const [beniDataCreateFormOpen, setBeniDataCreateFormOpen] =
    useState<boolean>(false);
  const toggleBeniDataEditFormOpen = () =>
    setBeniDataCreateFormOpen(!beniDataCreateFormOpen);

  // Contratti
  const [contrattiDataCreateFormOpen, setContrattiDataCreateFormOpen] =
    useState<boolean>(false);
  const toggleContrattiDataEditFormOpen = () =>
    setContrattiDataCreateFormOpen(!contrattiDataCreateFormOpen);

  // Toggle contact sections visibility
  const [showContactSections, setShowContactSections] = useState<boolean>(false);
  const toggleContactSections = () => setShowContactSections(!showContactSections);

  return (
    <>
      <Box>
        <BackButton />
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SectionTitle title="Cliente - Dati Anagrafici Base" />
          </AccordionSummary>
          <AccordionDetails>
            <Grid
              container
              rowSpacing={0.5}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <DisplayField title="Cognome" text={pef.cognome} fill={2.4} />
              <DisplayField title="Nome" text={pef.nome} fill={2.4} />
              <DisplayField title="Codice Fiscale" text={pef.codice_fiscale} fill={2.4} />
              <DisplayField title="Genere" text={pef.gender} fill={2.4} />
              <DisplayField
                title="Genesi Cliente"
                text={pef.anagraficacliente.genesi_cliente}
                fill={2.4}
              />
              <DisplayField
                title="Data di Nascita"
                text={displayFormatted(pef.data_di_nascita)}
                fill={2.4}
              />
              <DisplayField title="Luogo di Nascita" text={pef.birth_place} fill={2.4} />
              <Grid item xs={12} sm={4.8}></Grid>
              <Grid item xs={12} sm={2.4} display="flex" alignItems="center" justifyContent="center" gap={1}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<EditIcon />}
                  onClick={() => {
                    toggleMainDataEditFormOpen();
                  }}
                >
                  Modifica
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={toggleContactSections}
                >
                  {showContactSections ? 'Nascondi Dettagli' : 'Mostra Dettagli'}
                </Button>
              </Grid>
            </Grid>
          </AccordionDetails>
          <AccordionActions>
          </AccordionActions>
        </Accordion>

        {showContactSections && (
        <>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SectionTitle title="Cliente - Info Contatto Email" />
          </AccordionSummary>
          <AccordionDetails>
            <CustomerEmailsTable
              anagrafica_cliente_id={pef.id_cliente}
              createFormOpen={emailDataCreateFormOpen}
              toggleCreateFormOpen={toggleEmailDataCreateFormOpen}
            />
          </AccordionDetails>
          <AccordionActions>
            <Button
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              onClick={() => {
                toggleEmailDataCreateFormOpen();
              }}
            >
              Aggiungi
            </Button>
          </AccordionActions>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SectionTitle title="Cliente - Info Contatto Telefono" />
          </AccordionSummary>
          <AccordionDetails>
            <CustomerTelefoniTable
              anagrafica_cliente_id={pef.id_cliente}
              createFormOpen={telefonoDataCreateFormOpen}
              toggleCreateFormOpen={toggleTelefonoDataEditFormOpen}
            />
          </AccordionDetails>
          <AccordionActions>
            <Button
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              onClick={() => {
                toggleTelefonoDataEditFormOpen();
              }}
            >
              Aggiungi
            </Button>
          </AccordionActions>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SectionTitle title="Cliente - Indirizzi" />
          </AccordionSummary>
          <AccordionDetails>
            <CustomerIndirizziTable
              anagrafica_cliente_id={pef.id_cliente}
              record={{} as Indirizzo}
              createFormOpen={indirizziDataCreateFormOpen}
              toggleCreateFormOpen={toggleIndirizziDataEditFormOpen}
            />
          </AccordionDetails>
          <AccordionActions>
            <Button
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              onClick={() => {
                toggleIndirizziDataEditFormOpen();
              }}
            >
              Aggiungi
            </Button>
          </AccordionActions>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SectionTitle title="Cliente - Documenti" />
          </AccordionSummary>
          <AccordionDetails>
            <CustomerDocumentTable
              anagrafica_cliente_id={pef.id_cliente}
              record={{} as CustomerDocument}
              createFormOpen={documentCreateFormOpen}
              toggleCreateFormOpen={toggleDocumentEditFormOpen}
            />
          </AccordionDetails>
          <AccordionActions>
            <Button
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              onClick={() => {
                toggleDocumentEditFormOpen();
              }}
            >
              Aggiungi
            </Button>
          </AccordionActions>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SectionTitle title="Cliente - Conti" />
          </AccordionSummary>
          <AccordionDetails>
            <BankAccountTable
              anagrafica_cliente_id={pef.id_cliente}
              record={{} as BankAccount}
              createFormOpen={bankAccountCreateFormOpen}
              toggleCreateFormOpen={toggleBankAccountEditFormOpen}
            />
          </AccordionDetails>
          <AccordionActions>
            <Button
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              onClick={() => {
                toggleBankAccountEditFormOpen();
              }}
            >
              Aggiungi
            </Button>
          </AccordionActions>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SectionTitle title="Cliente - Credenziali Portali Vendita" />
          </AccordionSummary>
          <AccordionDetails>
            <CustomerCredenzialiPortaleVenditaTable
              anagrafica_cliente_id={pef.id_cliente}
              record={{} as CredenzialiPortaleVenditaModel}
              createFormOpen={portaliVenditaDataCreateFormOpen}
              toggleCreateFormOpen={togglePortaliVenditaDataCreateFormOpen}
              setEnableCreateButton={setEnableCreateButton}
            />
          </AccordionDetails>
          <AccordionActions>
            <Button
              disabled={!enableCreateButton}
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              onClick={() => {
                togglePortaliVenditaDataCreateFormOpen();
              }}
            >
              Aggiungi
            </Button>
          </AccordionActions>
        </Accordion>
        </>
        )}

        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SectionTitle title="Cliente - Beni Associati" />
          </AccordionSummary>
          <AccordionDetails>
            <BeneTableComponent
              alterFabVisibility={() => toggleBeniDataEditFormOpen()}
              fabVisible={false}
              enableCreate={beniDataCreateFormOpen}
              dettaglio={false}
              anagrafica_cliente_id={pef.id_cliente}
            />
          </AccordionDetails>
          <AccordionActions>
            <Button
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              onClick={() => {
                toggleBeniDataEditFormOpen();
              }}
            >
              Aggiungi
            </Button>
          </AccordionActions>
        </Accordion>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SectionTitle title="Cliente - Contratti Associati" />
          </AccordionSummary>
          <AccordionDetails>
            <ContrattiTableComponent
              alterFabVisibility={() => toggleContrattiDataEditFormOpen()}
              fabVisible={false}
              enableCreate={contrattiDataCreateFormOpen}
              anagrafica_cliente_id={pef.id_cliente}
            />
          </AccordionDetails>
          <AccordionActions>
            <Button
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              onClick={() => {
                toggleContrattiDataEditFormOpen();
              }}
            >
              Aggiungi
            </Button>
          </AccordionActions>
        </Accordion>
      </Box>

      {/* Edit Anagrafica Base */}
      <PersonaFisicaFormComponent
        initialData={pef}
        open={mainDataEditFormOpen}
        toggleOpen={toggleMainDataEditFormOpen}
        editEnabled={true}
      />
    </>
  );
};

export default PersonaFisicaDetailComponent;
